import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-youtube-video-insights-details',
  templateUrl: './help-youtube-video-insights-details.component.html'
})
export class HelpYoutubeVideoInsightsDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
